import React, { useState } from 'react';
import { CoreEntraIdUserExportUserPrincipalNameSettings, EntraIdUserExportUserPrincipalNameSource } from '../../../../../../models/CoreEntraIdUserModels';
import StringValueBuilderInput from '../StringValueBuilderInput';
import EnumInput from '../../../../../misc/EnumInput';
import * as EntraId from './EntraIdUserTypes';
import { Card, CardHeader, Button, Collapse, CardBody } from 'reactstrap';
import TextInput from '../../../../../misc/TextInput';
import BoolInput from '../../../../../misc/BoolInput';
import { useTranslation } from 'react-i18next';
import { StringValueBuilderPartValueSource } from '../../../../../../models/CoreModels';
import {
    defaultStringValueBuilderPartDefinitions,
    pickStringValueBuilderDefinitions
} from '../StringValueBuilderDefinitions';

export const entraIdStringValueBuilderPartDefinitions = pickStringValueBuilderDefinitions(
    defaultStringValueBuilderPartDefinitions,
    [
        StringValueBuilderPartValueSource.PERSON_FIRST_NAME,
        StringValueBuilderPartValueSource.PERSON_LAST_NAME,
        StringValueBuilderPartValueSource.RANDOM_FROM_CHARSET,
        StringValueBuilderPartValueSource.STUDENT_SCHOOL_YEAR,
        StringValueBuilderPartValueSource.PERIOD_AWARE_START_YEAR,
        StringValueBuilderPartValueSource.PERIOD_AWARE_END_YEAR,
        StringValueBuilderPartValueSource.CONSTANT,
        StringValueBuilderPartValueSource.YEAR_OF_BIRTH
    ]
);
interface EntraIdUserUserPrincipalNameSettingsProps {
    userPrincipalNameSettings: CoreEntraIdUserExportUserPrincipalNameSettings
    disabled?: boolean
    validation: string[]
    onChange: (x: CoreEntraIdUserExportUserPrincipalNameSettings) => void
}

const EntraIdUserUserPrincipalNameSettings: React.FC<EntraIdUserUserPrincipalNameSettingsProps> = (props) => {
    const [isOpen, setOpen] = useState<boolean>(true);
    const { t } = useTranslation(['configuration', 'common'])

    const updateConfig = (change: Partial<CoreEntraIdUserExportUserPrincipalNameSettings>) => {
        props.onChange({ ...props.userPrincipalNameSettings, ...change })
    }

    return (<Card className="mb-3">
        <CardHeader tag="h5">
            <Button outline color="secondary" style={{ width: '30px', float: 'right', lineHeight: '0.8', padding: '0.5rem' }} onClick={() => setOpen(!isOpen)}>{isOpen ? '-' : '+'}</Button>
            {t('entraIdUserPrincipalNameSettings.header', { ns: 'configuration' })}
        </CardHeader>
        <Collapse isOpen={isOpen}>
            <CardBody>
                <EnumInput
                    title={t('entraIdUserPrincipalNameSettings.source.title', { ns: 'configuration' })}
                    name="userPrincipalNameSettings.source"
                    value={props.userPrincipalNameSettings.source}
                    options={EntraId.ExportUserPrincipalNameSource.map(key => ({
                        value: key,
                        text: t(`entraIdUserPrincipalNameSettings.source.options.${key}`, { ns: 'configuration' })
                    }))}
                    onChange={(_, value) => updateConfig({ source: value })}
                    disabled={props.disabled}
                />

                {(props.userPrincipalNameSettings.source === EntraIdUserExportUserPrincipalNameSource.GENERATED) &&
                    <StringValueBuilderInput
                    name='userPrincipalNameSettings.stringValueBuilderParts'
                    parts={props.userPrincipalNameSettings.stringValueBuilderParts}
                    onChange={(_, value) => updateConfig({ stringValueBuilderParts: value })}
                    disabled={props.disabled}
                    partDefinitions={entraIdStringValueBuilderPartDefinitions}
                    />}

                <EnumInput
                    title={t('entraIdUserPrincipalNameSettings.settingBehaviour.title', { ns: 'configuration' })}
                    name="userPrincipalNameSettings.settingBehaviour"
                    value={props.userPrincipalNameSettings.settingBehaviour}
                    options={EntraId.ExportSettingsBehaviour.map(key => ({
                        value: key,
                        text: t(`entraIdUserPrincipalNameSettings.settingBehaviour.options.${key}`, { ns: 'configuration' })
                    }))}
                    onChange={(_, value) => updateConfig({ settingBehaviour: value })}
                    disabled={props.disabled}
                />

                <BoolInput
                    title={t('entraIdUserPrincipalNameSettings.forceDomainName.title', { ns: 'configuration' })}
                    name="userPrincipalNameSettings.forceDomainName"
                    value={props.userPrincipalNameSettings.forceDomainName}
                    disabled={props.disabled}
                    updateValue={(_, value) => updateConfig({ forceDomainName: value })}
                    invalidFeedback={t('entraIdUserPrincipalNameSettings.forceDomainName.invalidFeedback', { ns: 'configuration' })}
                    invalid={props.validation.indexOf("userPrincipalNameSettings.forceDomainName") !== -1}
                />

                {(props.userPrincipalNameSettings.forceDomainName) &&
                    <TextInput
                        title={t('entraIdUserPrincipalNameSettings.forceDomainNameValue.title', { ns: 'configuration' })}
                        name="userPrincipalNameSettings.forceDomainNameValue"
                        value={props.userPrincipalNameSettings.forceDomainNameValue || ""}
                        disabled={props.disabled}
                        updateValue={(_, value) => updateConfig({ forceDomainNameValue: value })}
                        invalidFeedback={t('entraIdUserPrincipalNameSettings.forceDomainNameValue.invalidFeedback', { ns: 'configuration' })}
                        invalid={props.validation.indexOf("userPrincipalNameSettings.forceDomainNameValue") !== -1}
                    />}

            </CardBody>
        </Collapse>
    </Card>);
}

export default EntraIdUserUserPrincipalNameSettings;
